// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__1_iyE","radioRow":"SimpleQuestionBuilderModal_radioRow__2ITfW"};